import { render, staticRenderFns } from "./BizInsuranceInvoiceConfigForm.vue?vue&type=template&id=3bfe7157&"
import script from "./BizInsuranceInvoiceConfigForm.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceInvoiceConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports